// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartSelectionPopup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!(function () {
  var React = require('react');
  var Popup = require('share/components/controls/CommonPopup/Izenda.Popup');

  var SearchCriteria = require('./Izenda.SearchCriteria');
  var SearchResult = require('./Izenda.SearchResult');
  var SearchProcessBar = require('./Izenda.SearchProcessBar');
  var constants = require('logic/data/Izenda.ReportPartSelectionConstants');
  var connect = require('share/enhancers/Izenda.Connect');
  var action = require('./Izenda.ReportPartSelectionPopupAction');

  var ReportPartSelectionPopup = connect(action)(React.createClass({
    propTypes: {
      reportPartSelectionStore: React.PropTypes.object.isRequired,
      onAccept                : React.PropTypes.func.isRequired,
      onReject                : React.PropTypes.func.isRequired
    },

    componentWillUnmount: function() {
      this.props.reportPartSelectionStore.destroy();
    },

    render: function () {
      var props = this.props;
      var localization = props.localization;
      var reportPartSelectionStore = props.reportPartSelectionStore;
      var reportPartSelection = props.reportPartSelectionStore.reportPartSelection;
      var header = props.type === constants.TYPE.REPORT_PART ?
          localization.getText('DASHBOARD_LABEL_REPORT_PART_SELECTION') :
          localization.getText('DASHBOARD_LABEL_REPORT_SELECTION');

      return (
        <Popup visible
               type="none"
               sizeClass="modal-lg"
               onClosing={props.onReject}
               containerClass="izenda-ReportPartSelectionPopup-modal">
          <Popup.Header title={header}/>
          <Popup.Body className="izenda-ReportPartSelectionPopup">
            {!props.isShowResult && <SearchCriteria
              reportPartSelectionStore={reportPartSelectionStore}
              reportPartSelection={reportPartSelection}
              showResult={props.showResult}
              excludeIds={props.excludeIds}/>}
            <SearchProcessBar
              reportPartSelectionStore={reportPartSelectionStore} />
            {props.isShowResult && <SearchResult reportPartSelection={reportPartSelection} {...props} />}
          </Popup.Body>
        </Popup>
        );
    }
  }));

  ReportPartSelectionPopup.$popupName = 'ReportSelectionPopup';

  module.exports = ReportPartSelectionPopup;
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/ReportPartSelectionPopup/Izenda.ReportPartSelectionPopup.jsx